export const GO_SERVICE_QUERY_KEYS = {
  all: ["go-service"] as const,
  programEquipments: () => [...GO_SERVICE_QUERY_KEYS.all, "program-equipments"] as const,
  services: () => [...GO_SERVICE_QUERY_KEYS.all, "services"] as const,
  serviceProfile: (userId: number) => [...GO_SERVICE_QUERY_KEYS.all, "service-profile", userId] as const,
  serviceProfileForClient: (userId: number) =>
    [...GO_SERVICE_QUERY_KEYS.all, "service-profile-for-client", userId] as const,
  visitServiceProfile: (userId: number) => [...GO_SERVICE_QUERY_KEYS.all, "visit-service-profile", userId] as const,
  serviceFeedback: (userId: number) => [...GO_SERVICE_QUERY_KEYS.all, "feedback", userId] as const,
  serviceFeedbackForClient: (userId: number) => [...GO_SERVICE_QUERY_KEYS.all, "feedback-for-client", userId] as const,
  userServices: (userId: number) => [...GO_SERVICE_QUERY_KEYS.all, "services", userId] as const,
  trendingServices: () => [...GO_SERVICE_QUERY_KEYS.all, "trending-services"] as const,
  topServiceProviders: () => [...GO_SERVICE_QUERY_KEYS.all, "top-service-providers"] as const,
  service: (serviceId: number) => [...GO_SERVICE_QUERY_KEYS.all, "service", serviceId] as const,
  serviceRequest: (id: number) => ["service-request", id],
  receivedRequests: () => [...GO_SERVICE_QUERY_KEYS.all, "received-requests"] as const,
  orderedRequests: () => [...GO_SERVICE_QUERY_KEYS.all, "ordered-requests"] as const,
  receivedContracts: () => [...GO_SERVICE_QUERY_KEYS.all, "received-contracts"] as const,
  orderedContracts: () => [...GO_SERVICE_QUERY_KEYS.all, "ordered-contracts"] as const,
  receivedProgramRequests: () => [...GO_SERVICE_QUERY_KEYS.all, "received-program-requests"] as const,
  orderedProgramRequests: () => [...GO_SERVICE_QUERY_KEYS.all, "ordered-program-requests"] as const,
  contractDetails: (contractId: number) => [...GO_SERVICE_QUERY_KEYS.all, "contract", contractId] as const,
  contract: () => [...GO_SERVICE_QUERY_KEYS.all, "contract"] as const,
  serviceBanners: () => [...GO_SERVICE_QUERY_KEYS.all, "service-banners"] as const,
};
